'use client';
import * as React from "react";
export const useRatingContextValues = (ratingState)=>{
    const { color, hoveredValue, iconFilled, iconOutline, itemLabel, name, step, size, value } = ratingState;
    const ratingItem = React.useMemo(()=>({
            color,
            hoveredValue,
            iconFilled,
            iconOutline,
            interactive: true,
            itemLabel,
            name,
            step,
            size,
            value
        }), [
        color,
        hoveredValue,
        iconFilled,
        iconOutline,
        itemLabel,
        name,
        step,
        size,
        value
    ]);
    return {
        ratingItem
    };
};
